import { createFileRoute } from '@tanstack/react-router';
import { fetchChats } from '../../../api/chats';

export const Route = createFileRoute('/_layout-app/app/chats')({
  beforeLoad: async ({ context }) => {
    // Prefetch the conversations list
    await context.queryClient?.prefetchQuery({
      queryKey: ['chats'],
      queryFn: fetchChats,
      staleTime: 1000 * 60 * 5, // 5 minutes
    });
  },
});
